/**
 * @fileoverview Content component.core
 */
'use strict';
// React Import
import React, { Component } from 'react';
// Core Import
import Loading from './Loading';
// Library Import
import _ from 'lodash';

import * as ConstUtil from '../../util/ConstUtil';
import * as StringUtil from '../../util/StringUtil';
import * as StorageUtil from '../../util/StorageUtil';
import * as LogUtil from '../../util/LogUtil';

import CarCollection from '../../collection/CarCollection';

/**
 * Content共通コンポーネント
 *
 * @class Main
 * @extends {Component}
 */
class Content extends Component {
  constructor(props) {
    super(props);

    this.carList = [];

    _.bindAll(
      this,
      'changeValue',
      'searchClear',
      'changeRadioButton',
      'changeDateTime',
      'chengCarNoValid',
      'chengCarNoValidPattern'
    );
    this.carCollection = new CarCollection();
  }

  /**
   * ローディング表示
   *
   * @memberof Content
   */
  showLoading() {
    Loading.show();
  }

  /**
   * ローディング非表示
   *
   * @memberof Content
   */
  hideLoading() {
    Loading.hide();
  }

  /**
   * 日時変更
   *
   * @param {Object} event イベント
   * @param {Object} inst mobiscrollインスタンス
   * @memberof Content
   */
  changeDateTime(event, inst) {
    this.setState({
      [inst.settings.id]: inst.getVal()
    });
  }

  /**
   * 入力値/選択値変更
   *
   * @param {Object} event イベント
   * @memberof Content
   */
  changeValue(event) {
    // 画面に反映
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  /**
   * 入力値/選択値変更 + 入力内容検証
   *
   * @param {*} validPattern
   * @param {*} invalidPattern
   * @returns
   * @memberof Content
   */
  changeValueValidate(validPattern) {
    return event => {
      const validPatternLine = new RegExp('^[' + validPattern + ']*$');
      if (!event.target.value.match(validPatternLine)) {
        const invalidPattern = new RegExp('[^' + validPattern + ']', 'g');
        event.target.value = event.target.value.replace(invalidPattern, '');
      }
      this.changeValue(event);
    };
  }

  /**
   * チェックボックス選択肢取得
   *
   * @param {Array} itemList リスト
   * @returns
   * @memberof Content
   */
  getCheckSelectOptions(itemList, checkedList, idName) {
    if (_.isEmpty(itemList)) {
      return;
    }
    let options = [];
    for (let item of itemList) {
      let checked = false;
      let selectedId = _.filter(checkedList, { [idName]: Number(item.id) });
      // 選択済みの場合
      if (!_.isEmpty(selectedId)) {
        checked = true;
      }
      options.push({ id: Number(item.id), text: item.name, checked: checked });
    }
    return options;
  }

  /**
   * ラジオボタン変更
   *
   * @param {Object} event イベント
   * @memberof Content
   */
  changeRadioButton(event) {
    if (_.isEmpty(event)) {
      return;
    }
    if (_.isEmpty(event.target)) {
      return;
    }
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  /**
   * 種別の初期値取得
   *
   * @param {String} storageDate localStorageの値
   * @param {String} type 種別
   * @returns
   * @memberof TotalWorkspaceList
   */
  getDefaultSearchCategory(conponentName, itemName) {
    // LocalStorageに検索条件を保存している場合
    const memoryDate = StorageUtil.getSettingMemory(conponentName, itemName);
    if (!_.isEmpty(memoryDate)) {
      return memoryDate;
    }
    return 1;
  }

  /**
   * 通信失敗時共通処理
   *
   * @param {Object} err エラー
   * @returns
   * @memberof Content
   */
  failureConnection(err) {
    this.hideLoading();
    this.errorCommon(err);
  }

  /**
   * 汎用エラー処理
   *
   * @memberof Content
   */
  generalError() {
    // メッセージ画面に遷移
    this.props.history.push(
      ConstUtil.Common.COMPONENT.MESSAGE.URL +
        StringUtil.createQueryParam([
          {
            key: ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.MAIN,
            value:
              ConstUtil.Message.COMMON.MESSAGE_001 +
              ConstUtil.Message.COMMON.MESSAGE_002
          }
        ])
    );
  }

  /**
   * 通信エラー処理
   *
   * @memberof Content
   */
  connectionError() {
    // メッセージ画面に遷移
    this.props.history.push(
      ConstUtil.Common.COMPONENT.MESSAGE.URL +
        StringUtil.createQueryParam([
          {
            key: ConstUtil.Common.QUERY_PARAMETER_KEY_LIST.MAIN,
            value:
              ConstUtil.Message.COMMON.MESSAGE_001 +
              ConstUtil.Message.COMMON.MESSAGE_002
          }
        ])
    );
  }

  /**
   * 異常応答時処理
   *
   * @param {Object} err エラーオブジェクト
   * @returns
   * @memberof Content
   */
  errorCommon(err) {
    // エラーオブジェクトがない場合
    if (_.isEmpty(err) || _.isEmpty(err.response)) {
      this.generalError();
      return;
    }
    switch (err.response.status) {
      // 通信エラー
      case ConstUtil.Common.HTTP_STATUS_CODE_LIST.CONNECTION_ERROR:
        this.connectionError();
        break;
      // 認証エラー
      case ConstUtil.Common.HTTP_STATUS_CODE_LIST.UNAUTHORIZED:
        localStorage.clear();
        // ログイン画面遷移
        this.props.history.push(ConstUtil.Common.COMPONENT.LOGIN.URL);
        break;
      // 400エラー
      case ConstUtil.Common.HTTP_STATUS_CODE_LIST.BAR_REQUEST:
        this.generalError();
        break;
      default:
        this.generalError();
        break;
    }
  }

  /**
   * リザルトコードの有無チェック
   *
   * @param {Object} err エラー
   * @returns
   * @memberof Content
   */
  isExitResultCode(err) {
    // エラーオブジェクトがない場合
    if (_.isEmpty(err) || _.isEmpty(err.response)) {
      return false;
    }
    // 400応答の場合
    if (
      err.response.status === ConstUtil.Common.HTTP_STATUS_CODE_LIST.BAR_REQUEST
    ) {
      // レスポンスデータのチェック
      if (_.isEmpty(err.response.data)) {
        return false;
      }
      if (_.isNumber(err.response.data.result_code)) {
        // リザルトコード有り
        return true;
      }
    }
    return false;
  }

  /**
   * エラーメッセージ表示処理
   *
   * @param {Object} err エラー
   * @returns
   * @memberof Content
   */
  showErrorMessage(err) {
    // 400応答の場合
    if (this.isExitResultCode(err)) {
      // バリデーションエラー以外は上部にエラーメッセージを表示
      if (
        err.response.data.result_code !==
        ConstUtil.Common.RESULT_CODE_LIST.REQUEST_ERROR
      ) {
        this.setState({
          messageList: [
            ConstUtil.resultCodeMessage(err.response.data.result_code)
          ]
        });
        return;
      }
    }
    // 異常応答共通処理
    this.errorCommon(err);
  }

  /**
   * ファイルダウンロード
   *
   * @param {Array} documentList ドキュメントリスト
   * @memberof Content
   */
  fileDownLoad(documentList) {
    for (let documentItem of documentList) {
      // ダウンロードリンク要素を作成
      let downloadElement = document.createElement('a');
      downloadElement.download = documentItem.fileKey;
      downloadElement.href = documentItem.url;
      // 要素をクリックしダウンロードを実行
      downloadElement.click();
    }
  }

  /**
   * ファイルチェック
   *
   * @param {Object} file ファイル情報
   * @returns {String} エラーメッセージ
   * @memberof Content
   */
  checkUploadTsvFile(file) {
    // 拡張子チェック
    // ファイルの拡張子を取得(末尾から3文字抜き出す)
    let fileNameExtension = file.name.substr(file.name.length - 3, 3);
    // 拡張子がTSV以外の場合
    if (
      fileNameExtension.toLowerCase() !==
      ConstUtil.Common.FILE_NAME_EXTENSION.TSV
    ) {
      return ConstUtil.Message.COMMON.MESSAGE_078;
    }
    // ファイル名チェック
    // ファイル名取得
    let fileName = file.name.replace('.' + fileNameExtension, '');
    if (fileName.length > ConstUtil.Common.INPUT_MAX_LENGTH_LIST.MAX_50) {
      return ConstUtil.Message.COMMON.MESSAGE_041;
    }
    // ファイルサイズチェック
    if (file.size > ConstUtil.Common.FILE_TOTAL_MAX_SIZE) {
      return ConstUtil.Message.COMMON.MESSAGE_042;
    }
    LogUtil.d('Success File Check!');
    return '';
  }

  /**
   * ファイルチェック
   *
   * @param {Object} file ファイル情報
   * @returns {String} エラーメッセージ
   * @memberof Content
   */
  checkUploadCsvFile(file) {
    // 拡張子チェック
    // ファイルの拡張子を取得(末尾から3文字抜き出す)
    let fileNameExtension = file.name.substr(file.name.length - 3, 3);
    // 拡張子がCSV以外の場合
    if (
      fileNameExtension.toLowerCase() !==
      ConstUtil.Common.FILE_NAME_EXTENSION.CSV
    ) {
      return ConstUtil.Message.COMMON.MESSAGE_079;
    }
    // ファイル名チェック
    // ファイル名取得
    let fileName = file.name.replace('.' + fileNameExtension, '');
    if (fileName.length > ConstUtil.Common.INPUT_MAX_LENGTH_LIST.MAX_50) {
      return ConstUtil.Message.COMMON.MESSAGE_041;
    }
    // ファイルサイズチェック
    if (file.size > ConstUtil.Common.FILE_TOTAL_MAX_SIZE) {
      return ConstUtil.Message.COMMON.MESSAGE_042;
    }
    LogUtil.d('Success File Check!');
    return '';
  }

  searchClear(targetListName, sourceList, stateKey, selectedValue) {
    this.setState({
      [targetListName]: sourceList,
      [stateKey]: selectedValue
    });
  }

  /**
   * 削除用チェックリストのクリア
   *
   * @memberof Content
   */
  clearCheckList() {
    this.setState({
      checkList: []
    });
  }

  /**
   * 必須チェック + メッセージセットまで
   *
   * @param {*} value
   * @param {*} itemName
   * @returns true:有効 false:無効
   * @memberof Content
   */
  validateRequired(
    value,
    itemName,
    isSelectItem = false,
    stateName = 'messageList'
  ) {
    // チェック実行
    const isValid = !_.isEmpty(value);

    // チェックエラーの場合メッセージをセット
    if (!isValid) {
      const message =
        itemName +
        (isSelectItem
          ? ConstUtil.Message.COMMON.MESSAGE_033
          : ConstUtil.Message.COMMON.MESSAGE_031);
      this.setState({
        [stateName]: [message]
      });
    }
    return isValid;
  }

  /**
   * パターンチェック + メッセージセットまで
   *
   * @param {*} value
   * @param {*} pattern
   * @param {*} itemName
   * @param {*} patternName
   * @returns
   * @memberof Content
   */
  validatePattern(
    value,
    pattern,
    itemName,
    patternName,
    stateName = 'messageList'
  ) {
    // チェック実行
    const isValid = value.match(pattern);

    // チェックエラーの場合メッセージをセット
    if (!isValid) {
      const message =
        itemName +
        ConstUtil.Message.COMMON.MESSAGE_029 +
        patternName +
        ConstUtil.Message.COMMON.MESSAGE_030;
      this.setState({
        [stateName]: [message]
      });
    }
    return isValid;
  }

  /**
   * チェック処理実行
   *
   * @param {*} validators
   * @returns
   * @memberof Content
   */
  execValidators(validators, stateName = 'messageList') {
    // メッセージを初期化
    this.setState({ [stateName]: [] });

    for (const validator of validators) {
      // チェック処理を実行
      const isValid = validator();
      // エラーが1つある時点で返却
      if (!isValid) {
        return false;
      }
    }
    return true;
  }

  /**
   * 検索条件ステータス取得
   */
  getStatusList(collection, callback) {
    collection.getList(
      ConstUtil.Common.API_LIST.packageStatus,
      {
        success: callback.success.bind(this),
        failure: callback.failure.bind(this)
      },
      {}
    );
  }

  // 車両変更の値を変更した際に、変更した値を取得する（文字種チェック付き）
  chengCarNoValidPattern(validPattern) {
    return event => {
      // this.setState({ wcn: '' });
      const functionChageVlue = this.changeValueValidate(validPattern);
      functionChageVlue(event);
    };
  }

  // 車両変更の値を変更した際に、変更した値を取得する
  chengCarNoValid(event) {
    // this.setState({ wcn: '' });
    this.changeValue(event);
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/js/component/core/Content.jsx